// extracted by mini-css-extract-plugin
export default {"ways":"wABt8N","container":"A4_KqF","title":"Rd3dFD","content":"cNoHrg","diagram":"uhY0Sw","exit":"iauS4w"};